/**
 * The chest's flight from the end card to the full-screen stage (chestStage.ts `flyIn`): an eased arc of the framing —
 * where the chest sits on the canvas and the share of the height it fills — from the card's to the stage's, lifted up
 * and over on the way, with the chest pitching forward as it goes. Real time (the burst's slow motion never touches it).
 * Pure, so the curve can be tested.
 */
export interface Framing { x: number; y: number; fill: number }

export class ChestFlight {
  /** The flight's length (s). */
  static readonly Seconds = 0.55;
  /** How high it lifts at the top of the arc, as a share of the canvas height. */
  static readonly Lift = 0.06;
  /** How far the chest pitches forward mid-flight (rad). */
  static readonly Pitch = -0.25;
  private t = 0;

  constructor(readonly from: Framing, readonly to: Framing, readonly onLand: (() => void) | null) {}

  get done(): boolean { return this.t >= 1; }

  /** Advances by `dt` real seconds and writes the framing now into `out`; returns the chest's pitch now. */
  update(dt: number, height: number, out: Framing): number {
    const t = (this.t = Math.min(1, this.t + dt / ChestFlight.Seconds));
    const e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const arc = Math.sin(Math.PI * t);
    out.x = this.from.x + (this.to.x - this.from.x) * e;
    out.y = this.from.y + (this.to.y - this.from.y) * e - arc * ChestFlight.Lift * height;
    out.fill = this.from.fill + (this.to.fill - this.from.fill) * e;
    return this.done ? 0 : arc * ChestFlight.Pitch;
  }
}
